import useScrollReveal from '@/hooks/useScrollReveal';
import useOpenStatus from '@/hooks/useOpenStatus';

interface InfoItem {
  icon: string;
  label: string;
  value: string;
  target: string;
}

const infoItems: InfoItem[] = [
  { icon: 'ri-map-pin-line', label: 'Lokacija', value: 'Zamušani 2, Gorišnica', target: 'delovni-cas' },
  { icon: 'ri-time-line', label: 'Delovni čas', value: 'Poglej odpiralni čas', target: 'delovni-cas' },
];

export default function QuickInfoStrip() {
  const { ref, isVisible } = useScrollReveal({ threshold: 0.2 });
  const { isOpen } = useOpenStatus();

  const scrollTo = (id: string) => {
    if (!id) return;
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section ref={ref} className="relative z-20 bg-background-100 border-b border-background-200/40">
      <div className="w-full px-4 md:px-6 py-4 md:py-5">
        <div className="max-w-4xl mx-auto grid grid-cols-1 sm:grid-cols-3 gap-3 md:gap-5">
          {infoItems.map((item, idx) => (
            <button
              key={idx}
              onClick={() => scrollTo(item.target)}
              className={`group flex items-center gap-2.5 md:gap-3 p-2.5 md:p-3 rounded-lg text-left transition-all duration-700 ${
                item.target ? 'cursor-pointer hover:bg-background-200/50' : 'cursor-default'
              } ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
              style={{ transitionDelay: `${idx * 100}ms` }}
            >
              <div className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-full bg-accent-500/10 group-hover:bg-accent-500/20 flex-shrink-0 transition-colors duration-300">
                <i className={`${item.icon} text-accent-400 text-sm md:text-base`}></i>
              </div>
              <div className="min-w-0">
                <p className="text-[9px] md:text-[10px] font-semibold tracking-widest uppercase text-accent-400 mb-0.5">
                  {item.label}
                </p>
                <p className="text-[11px] md:text-xs text-foreground-200 leading-snug">{item.value}</p>
              </div>
            </button>
          ))}

          {/* Live open status */}
          <div
            className={`flex items-center gap-2.5 md:gap-3 p-2.5 md:p-3 rounded-lg transition-all duration-700 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
            style={{ transitionDelay: '200ms' }}
          >
            <div className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-full bg-accent-500/10 flex-shrink-0">
              <span className="relative flex h-2.5 w-2.5">
                {isOpen && (
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-accent-400 opacity-60"></span>
                )}
                <span
                  className={`relative inline-flex rounded-full h-2.5 w-2.5 ${
                    isOpen ? 'bg-accent-400' : 'bg-foreground-600'
                  }`}
                ></span>
              </span>
            </div>
            <div className="min-w-0">
              <p className="text-[9px] md:text-[10px] font-semibold tracking-widest uppercase text-accent-400 mb-0.5">
                Status
              </p>
              <p className="text-[11px] md:text-xs text-foreground-200 leading-snug">
                {isOpen ? 'Odprto zdaj' : 'Trenutno zaprto'}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}